import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { PaginateReqEntity, PaginateRespEntity } from '../../../interface';
import { ALPHABET_NUMBER_SPACE_PATTERN } from '../../../utils/pattern';
import { removeSpaceOnFirstCharacter, IsFormValid, checkValidInputOnKeyDown, displayDateFormat, scrollTop, checkActionAuthorization, downloadCsvFile } from '../../../service/shared.service';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../../../utils/null-check';
import { searchInputPlaceholder, toastOptObj } from "../../../utils/constants";
import { toast } from 'react-toastify';
import { RadioButton } from 'primereact/radiobutton';
import { AxiosResponse } from 'axios';
import { APIResponseEntity } from '../../../interface/api-responce';
import { APIToCreateSalesHeadHoldReason, APIToDeleteSalesHeadHoldReason, APIToExportSalesHeadHoldReason, APIToGetSalesHeadHoldReason, APIToUpdateSalesHeadHoldReason } from '../../../service/api-service';
import Loader from '../../../components/loader';
import { DataTable, DataTableSortEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DeleteConfirmationDialog from '../../../components/delete-confirmation';
import PrimePaginator from '../../../components/prime-paginator';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { SalesHeadHoldReasonDetailsEntity } from '../../../interface/production-master';
declare var $: any;

function SalesHeadHoldReason() {

    const navigate = useNavigate();

    const [reason, setReason] = useState<string>('');

    const [status, setStatus] = useState<boolean>(true);

    const [formErrors, setFormErrors] = useState<{ reason: string }>({
        reason: 'Please enter reason',
    });

    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [filterReq, setFilterReq] = useState<PaginateReqEntity>({
        pageSize: 10,
        pageNumber: 0,
        searchText: '',
        sortColumn: 'createdAt',
        sortOrder: '-1'
    });

    const [searchKeyword, setSearchKeyword] = useState<string>('');

    const [holdReasonDetails, setHoldReasonDetails] = useState<SalesHeadHoldReasonDetailsEntity[] | []>([])

    const [totalPageCount, setTotalPageCount] = useState(0);

    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>('');

    const [isUpdateRecordId, setIsUpdateRecordId] = useState<string>('');

    const [isEdit, setIsEdit] = useState<boolean>(false);

    const Status = [
        { name: 'Active', code: true },
        { name: 'Inactive', code: false },
    ];

    useEffect(() => { return () => { toast.dismiss(); }; }, []);

    useEffect(() => {
        const fetchData = async (): Promise<void> => {
            await fetchHoldReasons();
        };
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterReq]);

    useEffect(() => {
        $("#id_of_searchbox").keyup((event: any) => {
            const searchText: string = IsStringNullEmptyOrUndefined(event.target.value) ? '' : event.target.value;

            if (event.keyCode === 13 &&
                (
                    (IsStringNullEmptyOrUndefined(searchText))
                    ||
                    (!IsStringNullEmptyOrUndefined(searchText) && searchText.length >= 3)
                )
            ) {
                setFilterReq({ ...filterReq, searchText, pageNumber: 0 });
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchHoldReasons = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToGetSalesHeadHoldReason(filterReq);
        setHoldReasonDetails([]);
        setTotalPageCount(0);

        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setHoldReasonDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                }
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }

        setIsLoading(false);
    };

    const handleChange = (value: string) => {
        const isValid: boolean = ALPHABET_NUMBER_SPACE_PATTERN.test(value);
        setFormErrors({
            reason: IsStringNullEmptyOrUndefined(value)
                ? 'Please enter reason' :
                (!isValid ? 'Please enter valid reason' : !IsStringNullEmptyOrUndefined(value)
                    && value.length >= 3 ? '' : 'Minimum 3 characters are required')
        });

        setReason(value);
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (isValid) {
            setIsFormSubmitted(false);
            try {
                setIsLoading(true);
                const reqObj = { reason: reason.trim(), isActive: status };
                const resp: AxiosResponse<APIResponseEntity> = isEdit
                    ? await APIToUpdateSalesHeadHoldReason(isUpdateRecordId, reqObj)
                    : await APIToCreateSalesHeadHoldReason(reqObj);
                if (resp) {
                    if (resp.data && (resp.status === 200 || resp.status === 201)) {
                        const axiosResp: APIResponseEntity = resp.data;
                        if (axiosResp && axiosResp.status &&
                            (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                            toast.success(axiosResp.message, { ...toastOptObj });
                            resetForm();
                            setFilterReq({ ...filterReq, pageNumber: 0 });
                        } else {
                            toast.error(axiosResp.message, { ...toastOptObj });
                        }
                    }
                    else {
                        toast.error(resp.data.message, { ...toastOptObj });
                    }
                }
                setIsLoading(false);
            }
            catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
    };

    const deleteHoldReason = async (value: boolean) => {
        if (!value) { return; }
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteSalesHeadHoldReason(isDeleteRecordId);
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj });
                    resetForm();
                    setFilterReq({ ...filterReq, pageNumber: 0 });
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }
        setIsLoading(false);
    }

    const updateHoldReason = (rowData: SalesHeadHoldReasonDetailsEntity) => {
        setReason(rowData.reason);
        setStatus(rowData.isActive ?? true);
        setFormErrors({
            reason: !IsStringNullEmptyOrUndefined(rowData.reason) ? '' : "Please enter reason",
        });
        setIsUpdateRecordId(rowData.id);
        setIsEdit(true);
    }

    const dateCreatedBodyTemplate = (rowData: SalesHeadHoldReasonDetailsEntity) => {
        return displayDateFormat(rowData.createdAt as string);
    };

    const dateUpdatedBodyTemplate = (rowData: SalesHeadHoldReasonDetailsEntity) => {
        return displayDateFormat(rowData.updatedAt as string);
    };

    const actionIconTemplate = (rowData: SalesHeadHoldReasonDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {checkActionAuthorization('update', 'Sales Head Hold Reason') &&
                    <li data-toggle="tooltip" title="Edit">
                        <img src="assets/images/edit-icon.svg" alt="Edit" onClick={() => { updateHoldReason(rowData); scrollTop(); }} />
                    </li>}
                {checkActionAuthorization('delete', 'Sales Head Hold Reason') &&
                    <li data-toggle="tooltip" title="Delete" onClick={() => setIsDeleteRecordId(rowData.id)}>
                        <DeleteConfirmationDialog
                            isAccepted={deleteHoldReason}
                        />
                    </li>}
            </ul>
        );
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq({ ...filterReq, pageSize: event.rows, pageNumber: event.page });
    };

    const onSort = (event: DataTableSortEvent) => {
        setFilterReq({ ...filterReq, sortColumn: event.sortField, sortOrder: String(event.sortOrder), pageNumber: 0 });
    };

    const statusBodyTemplate = (rowData: SalesHeadHoldReasonDetailsEntity) => {
        return <span className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}> {rowData.isActive ? "Active" : "Inactive"}</span>;
    };

    const resetForm = (): void => {
        setIsUpdateRecordId('');
        setReason('');
        setStatus(true);
        setFormErrors({ reason: 'Please enter reason' });
        setIsEdit(false);
    }

    const fetchSalesHeadHoldReasonCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToExportSalesHeadHoldReason();
        setIsLoading(false);
        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (
                    axiosResp &&
                    axiosResp.data &&
                    axiosResp.status &&
                    axiosResp.statusCode === 200
                ) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName)
                        }
                    }
                };
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }

    };

    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="content-wrapper">
                <div className='col-12'>
                    <div className='row'>
                        <div className="col-lg-4 col-md-4 mb-md-0 mb-3">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <h4 className="card-title">Sales Head Hold Reason</h4>
                                        </div>
                                    </div>
                                    {checkActionAuthorization('create', 'Sales Head Hold Reason') ?
                                        <form onSubmit={handleSubmit}>

                                            <div className="form-group mb-3">
                                                <label>REASON <sup className='mandatory'>*</sup></label>
                                                <input type="text" name='reason' className="form-control form-control-lg"
                                                    onChange={(e) => handleChange(e.target.value)}
                                                    maxLength={50} value={reason}
                                                    onKeyDown={(event: any) => {
                                                        checkValidInputOnKeyDown(event, ALPHABET_NUMBER_SPACE_PATTERN);
                                                        removeSpaceOnFirstCharacter(event);
                                                    }}
                                                />
                                                {
                                                    isFormSubmitted &&
                                                    <small className="text-danger font-weight-500">
                                                        {formErrors.reason}
                                                    </small>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label>STATUS</label>
                                                <div className='d-flex mb-2'>
                                                    {Status.map((option: any) => (
                                                        <div key={option.code} className="d-flex align-items-center mb-2">
                                                            <RadioButton
                                                                inputId={String(option.code)}
                                                                name="status"
                                                                className='me-2'
                                                                value={option.code}
                                                                onChange={(e) => setStatus(e.value)}
                                                                checked={status === option.code}
                                                            />
                                                            <label className='me-5'>{option.name}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className='col-12'>
                                                <button type="submit" className="btn btn-block  btn-primary btn-md font-weight-medium m-0 me-2"
                                                >Save Reason</button>

                                                <button
                                                    type="button"
                                                    className="btn btn-cancel text-dark m-0"
                                                    onClick={() => IsStringNullEmptyOrUndefined(isUpdateRecordId) ? navigate('/settings') : resetForm()}>
                                                    {IsStringNullEmptyOrUndefined(isUpdateRecordId) ? 'Cancel' : 'Clear'}
                                                </button>
                                            </div>
                                        </form> : <div className="alert alert-danger" role="alert">
                                            You don't have permission to create sales head hold reasons
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <div className="card card-rounded">
                                <div className='card-body'>
                                    <div className="col-md-7 mb-3 ms-sm-auto">
                                        <div className="input-group search-grp">
                                            <div>
                                                {
                                                    checkActionAuthorization('upgrade', 'Allow to Export Sales Head Hold Reason') &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-block btn-success btn-md font-weight-medium m-0 me-2 pull-right"
                                                        onClick={() => fetchSalesHeadHoldReasonCsvDetails()}
                                                    >
                                                        Export Sales Head Hold Reason
                                                    </button>
                                                }
                                            </div>
                                            <img src="assets/images/search.svg"
                                                alt="search" className="input-group-text searchIptGrpTxt" />

                                            <input type="text" className='form-control form-control-lg searchInput'
                                                placeholder={searchInputPlaceholder}
                                                value={searchKeyword} id="id_of_searchbox"
                                                onChange={(e) => setSearchKeyword(e.target.value)}
                                            />
                                            {!IsStringNullEmptyOrUndefined(searchKeyword) && (
                                                <button
                                                    className="btn btn-cancel text-dark search-button-clear"
                                                    type="button"
                                                    onClick={() => {
                                                        setSearchKeyword('');
                                                        setFilterReq({ ...filterReq, searchText: '', pageNumber: 0 });
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <DataTable value={holdReasonDetails}
                                            sortField={filterReq.sortColumn}
                                            sortOrder={filterReq.sortOrder ? (parseInt(filterReq.sortOrder) as 1 | -1) : -1}
                                            onSort={onSort}
                                            emptyMessage="No hold reasons found"
                                        >
                                            <Column field="reason" header="Sales Head Hold Reason"></Column>
                                            <Column body={statusBodyTemplate} header="Status" ></Column>
                                            <Column field="createdAt" header="Created Date" body={dateCreatedBodyTemplate} sortable></Column>
                                            <Column field="updatedAt" header="Last Updated Date" body={dateUpdatedBodyTemplate} sortable></Column>
                                            {(checkActionAuthorization('update', 'Sales Head Hold Reason') || checkActionAuthorization('delete', 'Sales Head Hold Reason')) &&
                                                <Column header="Action" body={actionIconTemplate}></Column>
                                            }
                                        </DataTable>
                                    </div>

                                    {
                                        !IsNullOrEmptyArray(holdReasonDetails) && <PrimePaginator
                                            onPageChange={onPageChange}
                                            pageNumber={filterReq.pageNumber}
                                            pageSize={filterReq.pageSize}
                                            totalRecords={totalPageCount}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SalesHeadHoldReason;
